import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

interface ILiveMapStatusBadgeStyledProps {
  $backgroundColor: string;
  $borderColor: string;
  $color: string;
  $dataE2e: string;
}

/** Shared pill badge for live-map status columns (delay status, ride-start status). */
export const LiveMapStatusBadgeStyled = styled.span.attrs<
  ILiveMapStatusBadgeStyledProps & IStyledAttributes
>(({ $dataE2e }) => ({
  [DATA_E2E_KEY]: $dataE2e,
}))<ILiveMapStatusBadgeStyledProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  max-width: 100%;
  padding-block: 2px;
  padding-inline: 8px;
  border-radius: 10px;
  border: 1px solid ${({ $borderColor }) => $borderColor};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ $color }) => $color};
  font-size: 11px;
  font-weight: 500;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
